import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { DepositTaxCodeMap } from '../../../shared/utilities/Constants';
import { OptionDropdown, SelectControl } from '../../models/OptionDropdownSelect';
import { AchTransactionDetailsForm, CheckTransactionDetailsForm, ItTransactionDetailsForm, WireTransactionDetailsForm } from '../../models/form/TransactionFormGroup';

@Component({
  standalone: false,
  selector: 'mm-trust-deposit-code',
  templateUrl: './trust-deposit-code.component.html',
  styleUrls: ['./trust-deposit-code.component.scss']
})
export class TrustDepositCodeComponent implements OnInit {
  @Input() parentForm: FormGroup<CheckTransactionDetailsForm | WireTransactionDetailsForm | ItTransactionDetailsForm | AchTransactionDetailsForm>;
  private controlName = 'trustDepositCode';
  private depositCodes = DepositTaxCodeMap;
  private destroy$ = new Subject<void>();
  trustDepositCodeModel: SelectControl = {
    controlName: this.controlName,
    title: 'Deposit tax code',
    validationMessage: 'Trust deposit code needs to be selected',
    options: []
  };

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    if (!this.parentForm?.contains(this.controlName) || !this.parentForm?.get(this.controlName)?.value) {
      this.parentForm?.setControl('trustDepositCode', this.fb.nonNullable.control<typeof DepositTaxCodeMap[number]>('', Validators.required));
    }
    this.trustDepositCodeModel.options = this.depositCodes.map(category => new OptionDropdown(category, category.toUpperCase()));
  };

  ngOnDestroy(): void {
    this.parentForm?.removeControl('trustDepositCode');

    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}


